import { Countries } from './countriesList';

export const SHOW_ENGAGEMENT_FOR_COUNTRIES_LIST = [] as Array<Countries>;
